import React from 'react'
import './styles/Footer.css'

class Footer extends React.Component{
  render(){
    return(
      <footer className="footer__container">
        <div className="footer">
        David Valencia, © 2021
        </div>
      </footer>
    )
  }
}

export default Footer